function initTestimonials() {
  const blocks = document.querySelectorAll(".testimonials");

  blocks.forEach((block) => {
    const bigQuoteEl = block.querySelector(".testimonial-quote");
    const cards = Array.from(block.querySelectorAll(".testimonial-row .testimonial"));

    if (!bigQuoteEl || !cards.length) return;

    const setActive = (card) => {
      cards.forEach((c) => c.classList.remove("active"));
      card.classList.add("active");

      const quoteEl = card.querySelector(".quote");
      const quoteText = quoteEl ? quoteEl.textContent.trim() : "";
      bigQuoteEl.textContent = quoteText ? `"${quoteText}"` : '""';
    };

    // Center-most active first (by visual order in the row)
    const centerCard = cards[Math.floor(cards.length / 2)];
    setActive(centerCard);

    // Click to activate
    cards.forEach((card) => {
      card.addEventListener("click", () => setActive(card));
    });
  });
}

document.addEventListener("DOMContentLoaded", initTestimonials);